import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useEditInvoiceById } from '../../invoices/management/useEditInvoice';

export function InvoiceLinkCell({
  invoiceNumber,
  invoiceId,
}: {
  invoiceNumber: string;
  invoiceId: string;
}) {
  const handleEditInvoice = useEditInvoiceById();

  return (
    <div>
      <Button variant="anchor" onClick={() => handleEditInvoice(invoiceId)}>
        {invoiceNumber}
      </Button>
    </div>
  );
}
